import React from 'react';
import { Button, Table } from '@syneto/compass-react';
import Preloader from '../../../../components/preloader';
import { EDITIONS_SIZE_PER_PAGE_LIST } from '../../../../constants/editions';

const EditionsTable = (props) => {
	const { editions, pagination, isLoading, hasError, isSaving, onPaginationChange, onView, onEdit } = props;

	/*
	 * Only pagination comes back through the table: the list takes no filter.
	 */
	const handleTableChange = (type, { page, sizePerPage }) => {
		if (type !== 'pagination') {
			return;
		}

		onPaginationChange(page, sizePerPage);
	};

	const renderDescription = (cell) => {
		return cell ? cell : <span className="text-muted">No description</span>;
	};

	/*
	 * Only the count sits in the row: seven lines of licenses per edition made the table unreadable.
	 * What each license gives is behind View.
	 */
	const renderLicenses = (cell) => {
		const count = (cell ?? []).length;

		return count === 1 ? '1 license' : `${count} licenses`;
	};

	/*
	 * Edit goes dark while any write is in flight, which is what stops a second save racing the
	 * first against one list refresh. View is read-only, so it stays available.
	 */
	const renderActions = (cell, row) => {
		return (
			<>
				<Button role="tertiary" onClick={() => { return onView(row); }}>View</Button>
				<Button role="tertiary" disabled={isSaving} onClick={() => { return onEdit(row); }}>Edit</Button>
			</>
		);
	};

	/*
	 * A failed fetch leaves no rows, so "no editions" would state a result the request never
	 * returned. The alert above carries the reason; here we only decline to draw a conclusion.
	 */
	const emptyTableState = () => {
		if (isLoading) {
			return <Preloader dataIsLoading={true} />;
		}

		if (hasError) {
			return 'Editions could not be loaded.';
		}

		return 'No editions have been defined yet.';
	};

	return (
		<Table
			data={editions ?? []}
			keyField="id"
			remote
			pagination={{
				sizePerPageList: EDITIONS_SIZE_PER_PAGE_LIST,
				sizePerPage: pagination?.pageSize,
				showTotal: true,
				page: pagination?.page,
				totalSize: pagination?.totalItems
			}}
			onTableChange={handleTableChange}
			noDataIndication={emptyTableState()}
		>
			<Table.Col field="name" align="left">Name</Table.Col>
			<Table.Col field="code" align="left">Code</Table.Col>
			<Table.Col field="description" align="left" renderCell={renderDescription}>Description</Table.Col>
			<Table.Col field="licenses" align="left" renderCell={renderLicenses}>Licenses</Table.Col>
			<Table.Col field="actions" align="left" renderCell={renderActions}>Actions</Table.Col>
		</Table>
	);
};

export default EditionsTable;
